module.exports = __webpack_public_path__ + "img/valencia.74a1bc85.jpg";